export default {
  'common': {
    'termsCondition': 'Terms & Conditions',
    'privacyPolicy': 'Privacy Policy',
    "selectLang": "EN",
    'register': 'Register',
    'login': 'Login',
    'vietnamese': 'Vietnamese',
    'english': 'English',
    'notification': 'Notification',
    'logout': 'Logout',
    'viewMore': 'View more',
    'save': 'Save',
    'requiredFields': 'This field is required!',
    'search': 'Search',
    'loading': 'Loading',
    'networkError': "Network Error!",
    'nonumber': 'Number',
    'totalVoucher': 'Count: {num} voucher(s)',
    'notificationToast': {
      'passwordIncorrect': 'Password incorrect',
      'success': 'Success!',
      'errorVerification': 'Confirmation code is wrong',
      'oldPasswordInCorrect': 'Old password inCorrect',
      'youAreMissingInformation': 'You are missing information',
      'emailIsIncorrect': 'Email is incorrect',
      'incorrectTelephoneNumber': 'Incorrect telephone number',
      'incorrectDateOfBirth': 'Incorrect date of birth',
      'pleaseEnterANewPassword': 'Please enter a new password!',
      'pleaseConfirmYourNewPassword': 'Please confirm your new password!'
    },
    'changePassword': 'Change password',
    'registerToBecomeSupplier': 'Register to become a supplier',
    'close': 'Close',
    'help': 'Help',
    'start': 'Start',
    'back': 'Back',
    'tools': 'Tools',
    'sendEmail': 'Send email',
    'sendSelected': 'Send {num} selected vouchers',
    'sendAll': 'Send all email',
    'language': 'Language',
    'agree': 'Agree',
    'cancel': 'Cancel',
    'chooseAll': 'Select all',
    'detail': 'Detail',
    'loginWithGoogle': 'Login with Google',
    'googleAccountLink': 'Google Account Link',
    'facebookAccountLink': 'Facebook Account Link',
    'loginWithFacebook': 'Login with Facebook',
    'confirm': 'Confirm'
  },
  'menu': {
    'home': 'Home',
    'voucherList': 'Voucher list',
    'voucherWaitForConfirm': 'Voucher wait for confirm',
    'news': 'News',
    'myVoucher': 'My Voucher',
    'lookupVoucher': 'Lookup',
    'guide': 'Guide',
    'transferVoucher': 'Transfer voucher'
  },
  'register': {
    'title': 'Register Account',
    'entityAlreadyExistWithTypeNotCustomer': 'Email already exist with entity type not customer',
    'entityIsAlreadyExistWithAnotherUser': 'Email already exist entity with another user',
    'username': 'Username',
    'email': 'Email address',
    'password': 'Password',
    'confirmPassword': 'Confirm Password',
    'oldPassword': 'Old password',
    'newPassword': 'New password',
    'fullName': 'Full name',
    'phone': 'Phone',
    'gender': 'Gender',
    'dateOfBirth': 'Date of birth',
    'address': 'Address',
    'haveAnAccount': 'Have an account?',
    'registerWithGoogle': 'Register with google'
  },
  'login': {
    'loginInvalid': 'Username or password is incorrect',
    'login': 'Login',
    'username': 'Username',
    'password': 'Password',
    'forgotPassword': 'Forgot Password?',
    'doNotHaveAnAccount': 'Do Not Have An Account?',
    'createNewAccount': 'Create New Account',
    'notLoggedIn': 'Not logged in',
  },
  'dashboard': {
    'voucher': 'Voucher',
    'total': 'Total',
    'totalMoney': "Total Money",
    'vouches': 'Vouchers',
    'needConfirm': "need confirm",
    'isAboutToExpire': 'is about to expire',
    'notUseYet': 'not use yet',
    'using': 'using',
    'chart': {
      'chartLine': {
        'overview': 'OVERVIEW',
        'voucherUsed': 'Voucher used',
        'month': 'Month',
        'week': 'Week'
      },
      'chartBar': {
        'performance' : 'PERFORMANCE',
        'totalPurchased': 'Total purchased',
      },
      'chartDoughnut': {
        'overview': 'OVERVIEW',
        'const': 'Cost',
        'totalBudget': 'Total Budget',
        'voucherUsed': 'Voucher used',
        'voucherHasDelivered': 'Voucher Has Delivered',
        'VoucherNotUsed': 'Voucher Not Used',
        'voucher': 'Total voucher'
      }
    },
    'tabs': {
      'guide': 'Guide'
    }
  },
  'errors': {
    'notFound': "This page is not found",
    'backToHomePage': 'Back to home page'
  },
  'voucherManagement': {
    'all': "All",
    'waitForConfirmation': 'Wait For Confirmation',
    'using': 'Using',
    'notUseYet': 'Not In Use Yet',
    'used': 'Used',
    'table': {
      'numericalOrder': "Numerical Order",
      'image': 'Image',
      'voucherSerial': 'Serial',
      'voucherName': 'Voucher Name',
      'status': 'Status',
      'amount': 'Amount',
      'denominations': 'Denominations',
      'totalMoney': 'Total Money',
      'amountUsed': 'Amount Used',
      'theRemainingAmount': 'The Remaining Amount',
      'moneySpent': 'Money Spent',
      'moneyRemaining': 'Money Remaining',
      'action': 'Action'
    },
    'noVoucher': 'No Voucher Found',
    'chooseDate': 'Choose a date',
    'period': 'Period',
    'priceRange': 'Price range',
    'status': {
        'all': 'All',
        'expired': 'Expired',
        'used': 'Used',
        'waitingUse': 'Waiting for confirm used'
    }
  },
  'user': {
    'successfulActivation': 'Successful activation',
    'failedActivation': 'Activation failed, please try again later',
    'redirectLoginPage': 'Return to login page in 5 seconds',
    'resetPassword': {
      'linkNoLongerValid': 'The reset password link is no longer valid.'
    }
  },
  'forgotPassword': {
    'passwordRetrieval': 'Password Retrieval',
    'enterEmail': 'Enter email',
    'send': 'Send',
    'pleaseCheckEmailToChangePassword': 'Please check email to retrieve password !'
  },
  'profile': {
    'title': 'My Profile',
    'username': 'Username',
    'emailAddress': 'Email address',
    'fullName': 'Full Name',
    'phone': 'Phone',
    'dateOfBirth': "Date of birth",
    'gender': 'Gender',
    'address': 'Address',
    'genderType': {
      'male': 'Male',
      'female': 'Female',
      'other': 'Other'
    }
  },
  'lookUpVoucher': {
    'title': 'Look up',
    'statusVoucher': 'STATUS VOUCHER',
    'activationCode': 'Activation Code',
    'email': 'Email',
    'fullName': 'Full Name',
    'verification': 'Verification',
    'customer': 'CUSTOMER',
    'voucherSerial': 'Serial',
    'voucherName': 'Voucher Name',
    'supplier': 'Supplier',
    'price': 'Price',
    'effectiveDate': 'Effective Date',
    'validDate': 'Valid Date',
    'expiredDate': 'Expired',
    'status': 'Status',
    'watchInformation': 'Watch information',
    'seriNumber': 'S/N',
    'sentFrom': 'Sent from',
    'voucherPrice': 'Price',
    'voucherDiscount': 'Discount',
    'voucherSupplier': 'Supplier',
    'startDate': 'Start date',
    'endDate': 'End date',
    'detailInfo': 'Detail information',
    'voucherInfo': 'Voucher Information',
    'invalidVoucherLinkMessage': 'Invalid link information. Please recheck provided link or do resend your owned vouchers',
    'confirmAccessInfo': 'Confirm acess information',
    'inputCaptionEmailPhone': 'Enter email or phone received Voucher',
    'inputCaptionPhone': 'Enter phone number received Voucher',
    'inputHintEmail': 'E.g: your_email@sample.com',
    'inputHintPhone': 'E.g: 0912345678'
  },
  'evoucher': {
    'name': 'Voucher',
    'status': {
      'active': 'Active',
      'inactive': 'Unreleased',
      'new': 'New',
      'expired': 'Expired',
      'issuing': 'Issuing',
      'assigned': 'Assigned',
      'used': 'Used',
      'waiting': 'Waiting confirm from customer',
      'using_expired': 'Using expired',
      'distribution_expired': 'Distribution expired',
      'locked': 'In Using',
      'activated': 'Customers have received',
      'notUseYet': 'New voucher',
      'waitForConfirm': 'Waiting confirm',
      'transferred': 'Transferred'
    },
    'voucherNotUseYet': 'Voucher not use yet',
    'voucherWaitingConfirm': 'Voucher waiting confirm',
    'voucherUsed': 'Voucher used',
    'voucherTransferred': 'Voucher transferred',
    'used': 'This voucher has already been used',
    'confirmUsed': 'Confirm used',
    'description': 'Description',
    'termConditions': 'Term & Conditions',
    'remainQuantity': 'Remain quantity',
    'promotion': 'Promotion',
    'quantityIsOver': 'Quantity is over',
    'addressUsage': 'Address of use',
    'extraInfo': 'Extra information'
  },
  'voucherHistory': {
    'tableHistory': {
      'transactionHistory': 'Transaction history',
      'voucherSerial': 'Serial',
      'personPerform': 'Person perform',
      'receiver': 'Receiver',
      'executionDate': 'Execution date',
      'description': 'Description',
    },
    'implementAgencies': 'Implementing agencies',
    'peopleAction': 'People taking action',
    'receivingAgencies': 'Receiving agencies',
    'voucherUsageHistory': 'Voucher usage history',
    'dateAction': 'Date action',
    'action': 'Action',
    'customerAction': 'Customer taking action',
    'receivingCustomer': 'Receiving customer',
    'type': {
      'create': 'Create voucher',
      'distribute': 'Distribute to agents',
      'assigned': 'Distribute to customers',
      'used': 'Confirm using voucher directly',
      'sendConfirmUsedRequest': 'Send a request to use the voucher to the customer',
      'customerConfirmUsed': 'Customer confirmed to use voucher',
      'customerCancelUsed': 'Customer rejected to use voucher',
      'customerReturnUsed': 'Customer returned to use voucher',
      'deleted': 'Voucher deleted',
      'usedFromThirdParties': 'Used from third parties',
      'customerDeliveryVoucher': 'Customers deliver the voucher',
      'usePromotionVoucher': 'Use promotion voucher',
      'createPromotionVoucher': 'Create promotion voucher',
      'approveReconciliation': 'Approve check',
      'cancelReconciliation': 'Cancel check',
      'lockedVoucher': 'Locked using voucher',
      'confirmUseLockedVoucher': 'Confirmed locked-using voucher',
      'refundVoucher': 'Refunded locked voucher',
      'adminSystemDeliveryVoucher': 'Delivery voucher',
      'enableVoucher': 'Enable Voucher',
      'disableVoucher': 'Disable Voucher',
      'orderVoucher': 'Order voucher',
      'cancelOrderVoucher': 'cancel order voucher',
      'confirmOrderVoucher': 'Confirm order voucher',
      'publishedStoreChannel': 'Publish onto store channel',
      'takebackStoreChannel': 'Take back from store channel',
      'purchaseOrder': 'Purchase order',
      'cancelOrder': 'Purchase order',
      'extendExpiration': 'Extend expiration'
    },
    'description': {
      'undefined': 'Undefined action',
      'create': '[{entity}] create {amount} vouchers',
      'distribute': '{entity} distribute {amount} vouchers to [{toEntity}]',
      'assigned': '[{entity}] distribute {amount} voucher to customer [{customer}]',
      'used': '[{entity}] confirm to use voucher of [{customer}]',
      'sendConfirmUsedRequest': '[{entity}] send request using voucher confirmation to: [{customer}]',
      'customerConfirmUsed': 'Customer [{customer}] connfirmed using voucher via email sent from [{entity}]',
      'customerCancelUsed': '',
      'customerReturnUsed': '',
      'deleted': '[{entity}] deleted voucher',
      'usedFromThirdParties': '[{entity}] confirmed using voucher of [{customer}]',
      'customerDeliveryVoucher': 'Customer [{owner}] send voucher to [{customer}]',
      'usePromotionVoucher': '[{entity}] conrimed using promotion voucher for customer [{customer}]',
      'createPromotionVoucher': '[{entity}] published promotion vouchers',
      'approveReconciliation': '[{entity}] approved reconciliation from [{requestEntity}]',
      'cancelReconciliation': '[{entity}] rejected reconciliation from [{requestEntity}]',
      'lockedVoucher': '[{entity}] locked using voucher of [{customer}]',
      'confirmUseLockedVoucher': '[{entity}] confirmed to unlock and use locked using voucher',
      'refundVoucher': '[{entity}] refud locked usig voucher',
      'adminSystemDeliveryVoucher': 'Voucher has been delivered to [{customer}]',
      'enableVoucher': '[{entity}] enabled voucher',
      'disableVoucher': '[{entity}] disable voucher of [{customer}]',
      'orderVoucher': '[{storeChannel}]: add voucher to cart with order code [{code}]',
      'cancelOrderVoucher': 'Cancelled order code [{code}] from [{storeChannel}]',
      'confirmOrderVoucher': 'Payment confirmation for order code [{code}] from [{storeChannel}]',
      'publishedStoreChannel': 'Published voucher onto store channel [{storeChannel}]',
      'takebackStoreChannel': 'Take back voucher from store channel [{storeChannel}]',
      'purchaseOrder': 'Payment confirmation for order code [{code}] from [{storeChannel}]',
      'cancelOrder': 'Cancelled order code [{code}] from [{storeChannel}]',
      'extendExpiration': 'Extended using expired date'
    },
    'table': 'Table',
    'timeline': 'Timeline'
  },
  'entity': {
    'emailAlreadyExist': 'Email already exist !',
    'registerSuccessInactive': 'Register success, do you want go to login?',
    'registerSuccess': 'Register success',
  },
  'transactionBetweenCustomer': {
      'transactionMulti': 'Transfer selected voucher',
      'transactionSingle': 'Transfer voucher',
  },
  'sendVoucherInfoEmail': {
    'title': 'Confirm email sent',
    'content': 'Are you sure you want to send voucher information to this email?',
    'success': {
      'title': 'Email is successful!',
      'content': 'Your voucher information has been sent successfully!'
    },
    'error': {
      'title': 'Email failed!'
    }
  },
  'usedVoucherPromotion': {
    'yourPromotionalEVoucherHasBeenUsedSuccessfully': 'Your promotional EVoucher has been used successfully',
  },
  'introduction': {
    'welcome': 'Welcome to',
    'pagename': 'E-voucher checking page'
  },
  'help': {
    'lookupTitle': 'Lookup Voucher Introduction',
    'lookupInfo': 'Look up unused vouchers',
    'lookupOption1': 'Option 1: Eneter the serial number and validation code to check your Voucher',
    'lookupOption2': 'Option 2: Enter email and validation code to find your Voucher',
    'lookupOption3': 'Option 3: Enter phone number and validation code to find your Voucher',
    'registrationTitle': 'How to register to become a Supplier?',
    'registrationStep': 'Access and register suppilier info at {link}',
    'registrationHotline': 'Or contact us via hotline {link} for instructions',
    'usageTitle': 'Using Voucher Introduction',
    'usageBuy': 'Get vouchers from supplier or service provider',
    'usageCheck': 'Receive voucher information via email or sms.{0}Login to the eVoucher system to view detail voucher information, and transfer voucher to your friend or your parner',
    'usageExchange': 'Contact service provider to get advice on using vouchers for their products and services',
    'usageUsed': 'Provide the voucher serial number and activation code, or give the voucher QR code to use Voucher at acceptance using locations'
  },
  'footer': {
      'contact': 'Company',
      'mobileApp': 'Mobile Application',
      'connectUs': 'Connect with Avatar Technologies',
      'introduction': 'Introduction',
      'registerSupplier': 'How to be a supplier?'
  },
  'location': {
    'longitude': 'Longitude',
    'latitude': 'Latitude',
    'province': 'City / Province',
    'district': 'District',
    'ward': 'Ward',
    'address': 'Address',
    'addressTitle': 'Edit address'
  },
  'socialNetwork': {
    'notiAddSocialAccountLink': 'Are you sure you want to add a google account link?',
    'notiConfirmCreateAccountWithGoogle': 'Are you sure you want to create an account with this google account information?'
  }
}
